<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M15.6284 4.54947C16.0107 3.86982 16.9893 3.86982 17.3716 4.54947L29.1617 25.5097C29.5367 26.1763 29.055 27 28.2902 27H4.70985C3.94502 27 3.46331 26.1763 3.83827 25.5097L15.6284 4.54947Z"
        stroke="var(--bg-color)" stroke-width="2" stroke-linejoin="round" />
    <path
        d="M15.0293 10.5277C15.0134 10.2411 15.2415 10 15.5285 10H17.4715C17.7585 10 17.9866 10.2411 17.9707 10.5277L17.5262 18.5277C17.5115 18.7927 17.2924 19 17.027 19H15.973C15.7076 19 15.4885 18.7927 15.4738 18.5277L15.0293 10.5277Z"
        fill="var(--bg-color)" />
    <circle cx="16.5" cy="22.5" r="1.5" fill="var(--bg-color)" />
</svg>
